module.exports = __webpack_public_path__ + "img/15000.0b0b9fc8.jpg";